// extracted by mini-css-extract-plugin
module.exports = {"h1":"Profile_h1__2Sk1Q","card":"Profile_card__drmUj","linkGreen":"Profile_linkGreen__3k1EQ","doneIcon":"Profile_doneIcon__2ckZN","alertBody":"Profile_alertBody__k8ts7"};